import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '../utils/auth';

function PrivateRoute({ children, roles }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  const user = getUser();
  console.log('roles:', roles);
  if (roles && roles.indexOf(user.role) === -1) {
    return <Navigate to="/" />;
  }

  return children;
}

export default PrivateRoute;
